import { Trans } from 'next-i18next/pages';
import { type TransComponent as TransComponentType } from '@pkgs/components/providers/AppContextProvider';

export const TransComponent: TransComponentType = ({ components, i18nKey, t, values }) => {
  return <Trans components={components as never} i18nKey={i18nKey as never} t={t as never} values={values} />;
};
